import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Tabs from '../../../../../../../../features/components/Tabs'
import Field from '../../../../../../../../components/Form/Field'

import {
  BID_CAP,
  BUDGET,
  DIGITAL_ALLOCATION_IMPRESSIONS,
  DIGITAL_ALLOCATION_TYPE,
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  digitalAllocationTypeOptions
} from '../../../../fields'
import { selectedPartnershipCurrency } from '../../../../../../../../modules/selectors/partnerships'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

function DigitalRightCreateAllocationSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values } = formik

  const { currency_symbol: currencySymbol } = useSelector(selectedPartnershipCurrency)

  return (
    <section className={drawerFormClasses.section}>
      <div className={drawerFormClasses.tabsContainer}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Allocation')}</h3>
        <Tabs
          options={digitalAllocationTypeOptions}
          onSelectValue={value => formik.setFieldValue(DIGITAL_ALLOCATION_TYPE, value)}
          selectedValue={values[DIGITAL_ALLOCATION_TYPE]}
        />
      </div>
      <p>
        {t(
          'If you select a budget allocation, the partner will be able to spend up to that amount (including any margin). If you select impressions, the partner will not be able to choose an optimisation goal and the campaigns will deliver until the impressions goal has been met.'
        )}
      </p>
      {values[DIGITAL_ALLOCATION_TYPE] === DIGITAL_ALLOCATION_TYPE_BUDGET ? (
        <Field
          placeholder="Budget"
          type="number"
          formik={formik}
          name={BUDGET}
          symbol={currencySymbol}
          enableReinitialize
          inputMode="numeric"
        />
      ) : (
        <>
          <Field
            placeholder="Impressions"
            type="number"
            formik={formik}
            name={DIGITAL_ALLOCATION_IMPRESSIONS}
            enableReinitialize
            inputMode="numeric"
          />
          <p>
            {t(
              'Impressions based allocations will deliver until the impression goal has been reached. Please enter a bid cap for each thousand impressions (CPM) to limit the media cost.'
            )}
          </p>
          <Field
            placeholder="Bid cap"
            symbol={currencySymbol}
            type="number"
            formik={formik}
            name={BID_CAP}
            enableReinitialize
            inputMode="numeric"
          />
        </>
      )}
    </section>
  )
}

export default DigitalRightCreateAllocationSection
